"use client";

import { c as _c } from "react/compiler-runtime";
import type { isBlockedEmailDomain as IsBlockedEmailDomain } from "app/components/ContactForm/emailBlocklist";
import { InputField } from "app/components/Form/Fields";
import { useEffect, useRef } from "react";
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
function loadEmailBlocklist() {
  return import("app/components/ContactForm/emailBlocklist");
}
export function BusinessEmailField() {
  const $ = _c(3);
  const isBlockedEmailDomainRef = useRef(undefined);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      loadEmailBlocklist().then(mod => {
        isBlockedEmailDomainRef.current = mod.isBlockedEmailDomain;
      });
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <InputField name="email" label="Work Email" type="email" required={true} placeholder="address@email.com" autoComplete="email" pattern={EMAIL_PATTERN.source} validate={value => {
      const stringValue = typeof value === "string" ? value : "";
      if (!stringValue) {
        return "Please fill out this field.";
      }
      if (!EMAIL_PATTERN.test(stringValue)) {
        return "Please enter a valid work email to continue.";
      }
      if (isBlockedEmailDomainRef.current?.(stringValue)) {
        return "Please use a work email address rather than a personal one.";
      }
      return null;
    }} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}